import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor() {}

  isIphone(): boolean {
    return /iPhone/.test(navigator.userAgent);
  }
}
